module.exports = __webpack_public_path__ + "img/transformer_3p.2c440367.svg";